import React from 'react';
import { useQuery } from '@apollo/client';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Spin, Alert } from 'antd';
import { GET_TOP_SELLING_PRODUCTS } from '../mutations/dashboard';

const TopSellingProductsChart = () => {
  const { loading, error, data } = useQuery(GET_TOP_SELLING_PRODUCTS, {
    fetchPolicy: 'network-only',
  });

  if (loading) return <Spin />;
  if (error)
    return (
      <Alert message="Error" type="error" description={error.message} />
    );

  const chartData = data.topSellingProducts.map((product) => ({
    name: product.name,
    quantidade: product.totalQuantity,
  }));

  return (
    <ResponsiveContainer width="100%" height={500}>
      <BarChart
        layout="vertical" // Set chart layout to vertical for horizontal bars
        data={chartData}
        margin={{
          top: 20,
          right: 20,
          left: 0, // Increased left margin for long labels
          bottom: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        {/* XAxis now represents the quantitative values */}
        <XAxis type="number" />
        {/* YAxis now represents the product names */}
        <YAxis
          dataKey="name"
          type="category"
          tick={{
            fontSize: 12,
            fill: '#333',
          }}
          width={180} // Adjusted width for long labels
        />
        <Tooltip />
        <Legend />
        <Bar dataKey="quantidade" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TopSellingProductsChart;
